/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MailMagazineManagementAddFileUploadResponse } from './MailMagazineManagementAddFileUploadResponse';

export type MailMagazineManagementAddFileUploadResponseApiRespoonse = {
    data?: MailMagazineManagementAddFileUploadResponse;
    status?: MailMagazineManagementAddFileUploadResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MailMagazineManagementAddFileUploadResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

